<template>
    <div v-click-outside="onclickOutside">
        <button
            class="text-gray-700 bg-gray-100 hover:bg-gray-50 focus:ring-1 focus:outline-none focus:ring-gray-300 font-semibold rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800 w-"
            type="button"
            @click="toggleShowMenu">
            {{ subsidiarySelect?.name || 'No data' }}
            <svg class="w-2.5 h-2.5 ml-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
            </svg>
        </button>
        <!-- Dropdown menu -->
        <div 
            :class="{'absolute ': showMenu, 'hidden': !showMenu}"
            class="z-50 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
            <ul
                v-for="(subsidiary, index) in getSubsidiaries" :key="index"
                class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownHoverButton">
                <li>
                    <button 
                        @click="setSubsidiary(subsidiary)"
                        type="button" 
                        class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">{{ subsidiary.name }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import vClickOutside from 'click-outside-vue3'
    import useSubsidiaries from '@/modules/subsidiaries/composables/useSubsidiaries'
    import useAuth from '@/modules/auth/composables/useAuth'
    
    export default {
        directives: {
            clickOutside: vClickOutside.directive,
        },
        setup() {
            const showMenu = ref(false)

            const {
                setSubsidiarySelect,
                subsidiarySelect
            } = useSubsidiaries()

            const { getSubsidiaries } = useAuth()

            return {
                setSubsidiarySelect,
                subsidiarySelect,
                getSubsidiaries,
                showMenu,
                toggleShowMenu: () => {
                    showMenu.value = !showMenu.value
                },
                onclickOutside: () => {
                    showMenu.value = false
                }
            }
        },

        data() {
            return {
                subsidiaries: []
            }
        },

        mounted() {
            if (this.getSubsidiaries.length > 0) {
                this.setSubsidiarySelect(this.getSubsidiaries[0])
            }
        },

        methods: {
            setSubsidiary(subsidiary) {
                this.setSubsidiarySelect(subsidiary)
                this.toggleShowMenu()
            }
        }
    }
</script>